import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoriesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            内容分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按分类浏览您感兴趣的内容，快速定位所需信息
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-accent-100 rounded-xl mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mb-2">{cat.name}</h3>
              <p className="text-foreground-500 text-sm">{cat.count} 篇文章</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}